import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeneralSignUpComponent } from './general-sign-up.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiClient } from '../core/api-client.service';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MbscModule, MbscOptionsService } from '@mobiscroll/angular';
import { EditorModule } from '@tinymce/tinymce-angular';


@NgModule({
  declarations: [
    GeneralSignUpComponent
  ],
  imports: [
    CommonModule
    , BrowserModule
    , FormsModule
    , ReactiveFormsModule
    , NgxMaskDirective
    , NgxMaskPipe
    , MbscModule
    , EditorModule

  ],
  providers: [ApiClient
        ,MbscOptionsService 
    , provideNgxMask()],
})
export class SignUpModule { }
